import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { SvgIconProps } from "@mui/material/SvgIcon";

export function ChevronRight(props: SvgIconProps) {
  return <ChevronRightIcon fontSize="small" {...props} />;
}
